import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b761ca5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 개인정보 보호를 위해 "),
  /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "비밀번호를 변경"),
  /*#__PURE__*/_createTextVNode("해주세요. ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], {
        title: "비밀번호 변경",
        overrideOnClickBack: true,
        shouldShowUnderline: false,
        shouldHideBackButton: true,
        shouldHideCloseButton: true,
        onOnClickBack: $setup.goToMainLogin
      }),
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("p", null, "비밀번호를 변경한지 " + _toDisplayString($setup.passwordChangeCycleDays) + "일이 지났습니다.", 1 /* TEXT */),
        _hoisted_2
      ]),
      _createVNode($setup["ChangePasswordForm"], {
        isPasswordExpired: true,
        source: $setup.source
      }, null, 8 /* PROPS */, ["source"])
    ]),
    _: 1 /* STABLE */
  }))
}